import type { MouseEventHandler } from 'react';
import { AttachFile } from '@mui/icons-material';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

type Props = {
  onClick: MouseEventHandler<HTMLElement>;
  fileNumber?: number;
};

export const AttachFileButton = (props: Props) => {
  const { t: tCommon } = useTranslationWithLang('commons');
  return (
    <>
      <div
        className="cursor-pointer text-[--c-textinput-label] flex items-center whitespace-nowrap"
        onClick={props.onClick}
      >
        <AttachFile />
        <p className="text-sm">
          {props.fileNumber
            ? tCommon('TU000_094', { number: props.fileNumber })
            : tCommon('TU000_094', { number: '' })}
        </p>
      </div>
    </>
  );
};
